import React from 'react';

interface UserSummaryProps {
  userCounts: Record<string, number>;
  userColors: Record<string, string>;
  userLabels: Record<string, string>;
}

const UserSummary: React.FC<UserSummaryProps> = ({
  userCounts,
  userColors,
  userLabels
}) => {
  return (
    <div className="bg-white rounded-lg p-4 mt-6">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-4">
        {Object.entries(userCounts).map(([type, count]) => (
          <div 
            key={type}
            className="flex flex-col items-center p-4 bg-white border border-gray-100 rounded-lg "
          >
            <div
              className="w-4 h-4 rounded mb-2 flex items-center justify-center text-white font-bold text-sm"
              style={{ backgroundColor: userColors[type] }}
            >
              {/* {count} */}
            </div>
            <span className="text-lg font-semibold text-black text-center">
              {count}
            </span>
            <span className="text-xs text-black mt-1">
              {userLabels[type]}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserSummary;
